export { default } from './Confirm';


// WEBPACK FOOTER //
// ./src/pages/password/confirm/index.js